import * as z from "zod";

// Schema for a single table
export const tableSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  created_at: z.string(),
  edited_at: z.string(),
  options: z.record(z.string(), z.unknown()).nullable().optional(),
  kind: z.enum(["table", "virtual_table"]),
  owner_account_id: z.number(),
  owner_user_id: z.number().optional(),
  owner_zapier_customuser_id: z.number().optional(),
});

const tableFieldSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  edited_at: z.string(),
  type: z.string(),
  name: z.string(),
  options: z.record(z.string(), z.unknown()).optional(),
  config: z.record(z.string(), z.unknown()).optional(),
  is_order_field: z.boolean().optional(),
  is_filter_field: z.boolean().optional(),
  is_selected_field: z.boolean().optional(),
  source_field: z.record(z.string(), z.unknown()).optional().nullable(),
  linked_records_destination_tables: z
    .array(z.record(z.string(), z.unknown()))
    .optional()
    .nullable(),
});

const tableRecordSchema = z.object({
  data: z.record(z.string(), z.unknown()),
  id: z.string(),
  edited_at: z.string(),
  created_at: z.string(),
  schema_revision_id: z.number(),
  errors: z.record(z.string(), z.unknown()).optional(),
  orig_data: z.record(z.string(), z.unknown()).nullable().optional(),
  is_source_record: z.boolean().nullable().optional(),
});

const recordChangeSchema = z.object({
  change_id: z.string(),
  old: tableRecordSchema.nullable().optional(),
  new: tableRecordSchema.nullable().optional(),
  allow_deliver_hooks: z.boolean().optional(),
  changed_field_ids: z.array(z.number()).nullable().optional(),
  record_id: z.string().nullable().optional(),
});

// Response schemas
// POST /v1/tables-with-fields - Create table with fields
export const createTableResponseSchema = z.object({
  data: z.object({
    table: tableSchema,
    fields: z.array(
      z.object({
        old: tableFieldSchema.nullable().optional(),
        new: tableFieldSchema.nullable().optional(),
        kind: z.string(),
      }),
    ),
  }),
  meta: z.record(z.string(), z.unknown()).optional(),
});

// GET /v1/tables/:id - Get single table with fields
export const getTableResponseSchema = z.object({
  data: tableSchema,
  meta: z.record(z.string(), z.unknown()).optional(),
});

// GET /v1/tables - List all tables
export const listTablesResponseSchema = z.object({
  data: z.array(tableSchema),
  meta: z.object({}).optional(),
  links: z.object({}).optional(),
});

// GET /v1/tables/:id/fields - List table fields
export const listTableFieldsResponseSchema = z.object({
  data: z.array(tableFieldSchema),
  meta: z.object({}).optional(),
});

// POST /v1/tables/:id/records - Create records
export const createRecordsResponseSchema = z.object({
  data: z.array(recordChangeSchema),
  events: z.object({}).optional(),
  meta: z.record(z.string(), z.unknown()).nullable().optional(),
});
